module.exports = __webpack_public_path__ + "media/images/cats/all-absorb.jpg";